const BoldIcon = ({ isActive }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1264_20694"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="17"
        height="17"
      >
        <rect x="0.5" y="0.973877" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1264_20694)">
        <path
          d="M5.03247 13.6405V4.30721H8.7158C9.43803 4.30721 10.1047 4.52944 10.7158 4.97388C11.3269 5.41832 11.6325 6.03499 11.6325 6.82388C11.6325 7.39055 11.5047 7.82666 11.2491 8.13221C10.9936 8.43777 10.7547 8.65721 10.5325 8.79055C10.8102 8.91277 11.1186 9.14055 11.4575 9.47388C11.7964 9.80721 11.9658 10.3072 11.9658 10.9739C11.9658 11.9628 11.6047 12.6544 10.8825 13.0489C10.1602 13.4433 9.48247 13.6405 8.84914 13.6405H5.03247ZM7.04914 11.7739H8.78247C9.3158 11.7739 9.6408 11.6378 9.75747 11.3655C9.87414 11.0933 9.93247 10.8961 9.93247 10.7739C9.93247 10.6517 9.87414 10.4544 9.75747 10.1822C9.6408 9.90999 9.29914 9.77388 8.73247 9.77388H7.04914V11.7739ZM7.04914 7.97388H8.59914C8.9658 7.97388 9.23247 7.87944 9.39914 7.69055C9.5658 7.50166 9.64914 7.29055 9.64914 7.05721C9.64914 6.79055 9.55469 6.57388 9.3658 6.40721C9.17692 6.24055 8.93247 6.15721 8.63247 6.15721H7.04914V7.97388Z"
          fill={isActive ? '#00cf83' : '#89D3B8'}
        />
      </g>
    </svg>
  )
}

export default BoldIcon
